import cc from "classcat"
import { ReactNode } from "react"

interface Props {
  variant?: "success" | "alert" | "problem" | "neutral"
  className?: string
  children: ReactNode
}

export const Message = ({ variant, className, children, ...props }: Props) => {
  return (
    <div
      className={cc(["message", className, variant && `message--${variant}`])}
      {...props}
    >
      {children}
    </div>
  )
}
